import * as type from '../mutation-types'

const state = {
  scroll: { top: 0, type: null },
  showMenu: false,
  showSearch: false,
  showProductDetail: false,
  showAccountModal: false,
  showDrawerMenu: false,
  showFooterMenu: false,
  isLp: false,
  globalLock: false,
  isPc: false,
  basicModalInfo: null,
  isOpenBasicModal: false,
}

const getters = {}

const actions = {
  [type.UPDATE_MENU_VISIBILITY]({ commit }, boolean = false) {
    commit(type.UPDATE_MENU_VISIBILITY, boolean)
  },
  [type.UPDATE_SEARCH_VISIBILITY]({ commit }, boolean = false) {
    commit(type.UPDATE_SEARCH_VISIBILITY, boolean)
  },
  [type.UPDATE_PRODUCT_DETAIL_VISIBILITY]({ commit }, boolean = false) {
    commit(type.UPDATE_PRODUCT_DETAIL_VISIBILITY, boolean)
  },
  [type.RESET_SCROLL_TOP]({ commit }) {
    commit(type.UPDATE_SCROLL_TOP)
  },
  [type.UPDATE_SCROLL_TOP]({ commit }, value) {
    commit(type.UPDATE_SCROLL_TOP, value)
  },
  [type.ACCOUNT_MODAL_VISIBILITY]({ commit }, boolean) {
    commit(type.ACCOUNT_MODAL_VISIBILITY, boolean)
  },
  [type.DRAWER_MENU_VISIBILITY]({ commit }, boolean) {
    commit(type.DRAWER_MENU_VISIBILITY, boolean)
  },
  [type.FOOTER_MENU_VISIBILITY]({ commit }, boolean) {
    commit(type.FOOTER_MENU_VISIBILITY, boolean)
  },
  [type.IS_LP]({ commit }, boolean) {
    commit(type.IS_LP, boolean)
  },
  [type.GLOBAL_LOCK]({ commit }, stat) {
    commit(type.GLOBAL_LOCK, stat)
  },
  [type.IS_PC]({ commit }, boolean) {
    commit(type.IS_PC, boolean)
  },
  [type.OPEN_BASIC_MODAL]({ commit }, option) {
    commit(type.SET_BASIC_MODAL_INFO, option)
    commit(type.OPEN_BASIC_MODAL)
  },
  [type.CLOSE_BASIC_MODAL]({ commit }) {
    commit(type.CLOSE_BASIC_MODAL)
  },
}

const mutations = {
  [type.UPDATE_MENU_VISIBILITY](_state, boolean) {
    Object.assign(_state, { showMenu: boolean })
  },
  [type.UPDATE_SEARCH_VISIBILITY](_state, boolean) {
    Object.assign(_state, { showSearch: boolean })
  },
  [type.UPDATE_PRODUCT_DETAIL_VISIBILITY](_state, boolean) {
    Object.assign(_state, { showProductDetail: boolean })
  },
  [type.RESET_SCROLL_TOP](_state, value) {
    Object.assign(_state, {
      scroll: { top: 0, type: null }
    })
  },
  [type.UPDATE_SCROLL_TOP](_state, value) {
    Object.assign(_state, {
      scroll: {
        top: value,
        type: _state.scroll.top > value ? 'UP' : 'DOWN'
      }
    })
  },
  [type.ACCOUNT_MODAL_VISIBILITY](_state, boolean) {
    Object.assign(_state, { showAccountModal: boolean })
  },
  [type.DRAWER_MENU_VISIBILITY](_state, boolean) {
    Object.assign(_state, { showDrawerMenu: boolean })
  },
  [type.FOOTER_MENU_VISIBILITY](_state, boolean) {
    Object.assign(_state, { showFooterMenu: boolean })
  },
  [type.IS_LP](_state, boolean) {
    Object.assign(_state, { isLp: boolean })
  },
  [type.GLOBAL_LOCK](_state, stat) {
    Object.assign(_state, { globalLock: stat })
  },
  [type.IS_PC](_state, boolean) {
    Object.assign(_state, { isPc: boolean })
  },
  [type.OPEN_BASIC_MODAL](_state) {
    _state.isOpenBasicModal = true
  },
  [type.CLOSE_BASIC_MODAL](_state) {
    _state.isOpenBasicModal = false
  },
  [type.SET_BASIC_MODAL_INFO](_state, data) {
    _state.basicModalInfo = { ...data }
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/store/modules/uiState.js